var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_85873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 5.57003V25.2C24.4999 26.7464 23.2463 28 21.6999 28H6.3C4.7536 28 3.5 26.7464 3.5 25.2V2.8C3.5 1.2536 4.7536 0 6.3 0H18.4357L24.4999 5.57003Z",
    fill: "url(#paint0_linear_1617_85873)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1617_85873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 5.57003H19.1355C18.7489 5.57003 18.4355 5.25663 18.4355 4.87003V0L24.4997 5.57003Z",
    fill: "#FFE6E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.7841 17.8C11.7841 18.0562 11.7253 18.2914 11.6077 18.5056C11.4901 18.7156 11.3095 18.8857 11.0659 19.0159C10.8223 19.1461 10.5199 19.2112 10.1587 19.2112H9.4909V20.7988H8.4136V16.3762H10.1587C10.5115 16.3762 10.8097 16.4371 11.0533 16.5589C11.2969 16.6807 11.4796 16.8487 11.6014 17.0629C11.7232 17.2771 11.7841 17.5228 11.7841 17.8ZM10.0768 18.3544C10.2826 18.3544 10.4359 18.3061 10.5367 18.2095C10.6375 18.1129 10.6879 17.9764 10.6879 17.8C10.6879 17.6236 10.6375 17.4871 10.5367 17.3905C10.4359 17.2939 10.2826 17.2456 10.0768 17.2456H9.4909V18.3544H10.0768ZM14.0018 16.3762C14.468 16.3762 14.8754 16.4686 15.224 16.6534C15.5726 16.8382 15.8414 17.0986 16.0304 17.4346C16.2236 17.7664 16.3202 18.1507 16.3202 18.5875C16.3202 19.0201 16.2236 19.4044 16.0304 19.7404C15.8414 20.0764 15.5705 20.3368 15.2177 20.5216C14.8691 20.7064 14.4638 20.7988 14.0018 20.7988H12.3449V16.3762H14.0018ZM13.9325 19.8664C14.3399 19.8664 14.657 19.7551 14.8838 19.5325C15.1106 19.3099 15.224 18.9949 15.224 18.5875C15.224 18.1801 15.1106 17.863 14.8838 17.6362C14.657 17.4094 14.3399 17.296 13.9325 17.296H13.4222V19.8664H13.9325ZM19.8014 16.3762V17.2393H17.9996V18.1717H19.3478V19.0096H17.9996V20.7988H16.9223V16.3762H19.8014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1617_85873",
    x: 16.3355,
    y: -0.7,
    width: 8.86397,
    height: 8.37031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.7,
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1617_85873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1617_85873",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_85873",
    x1: 35.35,
    y1: -16.45,
    x2: -8.05,
    y2: 40.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#FFE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90788,
    stopColor: "#DC1818"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_85873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.82546d2342d21f7225f699868a08fd3f.svg";
export { ForwardRef as ReactComponent };